import { render, staticRenderFns } from "./Liquid.vue?vue&type=template&id=21427b2d&scoped=true&lang=pug&"
import script from "./Liquid.ts?vue&type=script&lang=ts&"
export * from "./Liquid.ts?vue&type=script&lang=ts&"
import style0 from "./Liquid.vue?vue&type=style&index=0&id=21427b2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21427b2d",
  null
  
)

export default component.exports